import "./App.css";
import Portfolio from "./Components/Portfolio"

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
function App() {
  return (
    <div className="bg-slate-900">
      <title>Mayur Adlak</title>
       <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      {/* <HomePage/> */}
<Portfolio/>
    </div>
  );
}

export default App;
